<template>
  <div class="mod-sale-order-line-detail">
    <el-form :inline="true" class="query-toolbar" @keyup.enter.native="searchHandle">
      <el-form-item label="销售单号">
        <el-input v-model="dataForm.salesOrderCode" size="small" clearable style="width:150px" placeholder="销售单号" />
      </el-form-item>
      <el-form-item label="客户名称">
        <el-input v-model="dataForm.customerName" size="small" clearable style="width:150px" placeholder="客户名称" />
      </el-form-item>
      <el-form-item label="产品编码">
        <el-input v-model="dataForm.materialCode" size="small" clearable style="width:150px" placeholder="产品编码" />
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('sale:salesOrder:list')" type="primary" size="small" @click="searchHandle">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="openMoreQueryDialog">更多查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="resetQuery">重置</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('sale:salesOrder:list')" type="primary" size="small" :loading="exportLoading" @click="exportHandle">导出</el-button>
      </el-form-item>
      <el-form-item v-if="moreQuerySummary">
        <span class="query-summary" :title="moreQuerySummary">{{ moreQuerySummary }}</span>
      </el-form-item>
    </el-form>

    <el-dialog title="更多查询条件" :visible.sync="queryDialogVisible" width="480px" append-to-body :close-on-click-modal="false" @open="syncQueryDraft">
      <el-form ref="queryForm" :model="queryDraft" label-width="100px" label-position="right" class="query-dialog-form" @keyup.enter.native="confirmMoreQuery">
        <el-form-item label="产品名称"><el-input v-model="queryDraft.materialName" size="small" clearable placeholder="产品名称" /></el-form-item>
        <el-form-item label="状态">
          <el-select v-model="queryDraft.orderStatus" size="small" clearable placeholder="全部" style="width:100%">
            <el-option label="开立" value="0" />
            <el-option label="已确认" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker v-model="queryDraft.orderDateStart" type="date" size="small" value-format="yyyy-MM-dd" clearable placeholder="开始日期" style="width:100%" />
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker v-model="queryDraft.orderDateEnd" type="date" size="small" value-format="yyyy-MM-dd" clearable placeholder="结束日期" style="width:100%" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="queryDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="confirmMoreQuery">确定</el-button>
      </span>
    </el-dialog>

    <el-table :data="dataList" border v-loading="loading" :header-cell-style="{ background: '#f5f7fa', color: '#606266', textAlign: 'center' }">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="salesOrderCode" label="销售单号" min-width="140" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('sale:salesOrder:info') && scope.row.salesOrderId" class="code-link" @click="viewSalesOrderHandle(scope.row.salesOrderId)">{{ scope.row.salesOrderCode }}</a>
          <span v-else>{{ scope.row.salesOrderCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="orderDate" label="订购日期" width="120" header-align="center" align="left">
        <template slot-scope="scope">{{ formatDate(scope.row.orderDate) }}</template>
      </el-table-column>
      <el-table-column prop="customerName" label="客户" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="lineSort" label="行号" width="70" header-align="center" align="left" />
      <el-table-column prop="materialCode" label="产品编码" min-width="130" header-align="center" align="left" />
      <el-table-column prop="materialName" label="产品名称" min-width="150" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="specs" label="规格型号" min-width="120" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="unitName" label="单位" width="80" header-align="center" align="left" />
      <el-table-column prop="quantity" label="订购数量" width="100" header-align="center" align="left" />
      <el-table-column prop="shippedQuantity" label="已出库" width="100" header-align="center" align="left" />
      <el-table-column prop="price" label="含税单价" width="100" header-align="center" align="left" />
      <el-table-column prop="amount" label="行金额" width="110" header-align="center" align="left" />
      <el-table-column prop="deliveryDate" label="交货日期" width="120" header-align="center" align="left">
        <template slot-scope="scope">{{ formatDate(scope.row.deliveryDate) }}</template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="120" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="orderStatus" label="状态" width="90" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag v-if="String(scope.row.orderStatus) === '2'" type="success" size="small">已确认</el-tag>
          <el-tag v-else type="info" size="small">开立</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[20, 50, 100, 200]"
      :page-size="pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
    />

    <sales-order ref="orderPage" class="hidden-order-page" />
  </div>
</template>

<script>
import SalesOrder from './SalesOrder.vue'
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'

function emptyMoreQueryForm() {
  return { materialName: '', orderStatus: '', orderDateStart: '', orderDateEnd: '' }
}
function emptyQueryForm() {
  return { salesOrderCode: '', customerName: '', materialCode: '', ...emptyMoreQueryForm() }
}

export default {
  name: 'SalesOrderLineDetail',
  components: { SalesOrder },
  data() {
    return {
      queryDialogVisible: false,
      dataForm: emptyQueryForm(),
      queryDraft: emptyMoreQueryForm(),
      dataList: [],
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      loading: false,
      exportLoading: false,
      permCodes: []
    }
  },
  computed: {
    moreQuerySummary() {
      const parts = []
      const f = this.dataForm
      if (f.materialName) parts.push('产品名称：' + f.materialName)
      if (f.orderStatus === '0') parts.push('状态：开立')
      if (f.orderStatus === '2') parts.push('状态：已确认')
      if (f.orderDateStart) parts.push('开始：' + f.orderDateStart)
      if (f.orderDateEnd) parts.push('结束：' + f.orderDateEnd)
      if (!parts.length) return ''
      if (parts.length === 1) return parts[0]
      return '更多条件 ' + parts.length + ' 项'
    }
  },
  created() { this.loadPerms(); this.getDataList() },
  activated() { this.getDataList() },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    formatDate(val) { return val ? String(val).slice(0, 10) : '' },
    searchHandle() { this.pageIndex = 1; this.getDataList() },
    openMoreQueryDialog() { this.queryDialogVisible = true },
    syncQueryDraft() {
      this.queryDraft = {
        materialName: this.dataForm.materialName,
        orderStatus: this.dataForm.orderStatus,
        orderDateStart: this.dataForm.orderDateStart,
        orderDateEnd: this.dataForm.orderDateEnd
      }
    },
    confirmMoreQuery() {
      Object.assign(this.dataForm, this.queryDraft)
      this.pageIndex = 1
      this.queryDialogVisible = false
      this.getDataList()
    },
    viewSalesOrderHandle(salesOrderId) {
      if (!salesOrderId) return
      this.$nextTick(() => this.$refs.orderPage && this.$refs.orderPage.open(salesOrderId, true))
    },
    queryPayload() {
      return {
        currentPage: this.pageIndex,
        pageSize: this.pageSize,
        code: this.dataForm.salesOrderCode,
        salesOrderCode: this.dataForm.salesOrderCode,
        partnerName: this.dataForm.customerName,
        customerName: this.dataForm.customerName,
        materialCode: this.dataForm.materialCode,
        materialName: this.dataForm.materialName,
        status: this.dataForm.orderStatus,
        dateFrom: this.dataForm.orderDateStart,
        dateTo: this.dataForm.orderDateEnd
      }
    },
    getDataList() {
      this.loading = true
      request.post('/sale/salesOrder/lineList', this.queryPayload()).then(res => {
        const body = res.data || {}
        this.dataList = body.list || []
        this.total = body.totalCount || 0
      }).catch(err => {
        this.dataList = []
        this.total = 0
        this.$message.error((err && err.message) || '加载销售订单明细失败')
      }).finally(() => { this.loading = false })
    },
    resetQuery() {
      this.dataForm = emptyQueryForm()
      this.queryDraft = emptyMoreQueryForm()
      this.pageIndex = 1
      this.getDataList()
    },
    exportHandle() {
      this.exportLoading = true
      const body = this.queryPayload()
      delete body.currentPage
      delete body.pageSize
      request.post('/sale/salesOrder/lineExport', body, { responseType: 'blob' }).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = 'sales_order_line_detail.xlsx'
        a.click()
        window.URL.revokeObjectURL(url)
      }).catch(() => { this.$message.error('导出失败') }).finally(() => { this.exportLoading = false })
    },
    sizeChangeHandle(val) { this.pageSize = val; this.pageIndex = 1; this.getDataList() },
    currentChangeHandle(val) { this.pageIndex = val; this.getDataList() }
  }
}
</script>

<style scoped>
.query-toolbar { margin-bottom: 8px; }
.query-summary { max-width: 280px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: #909399; font-size: 12px; }
.query-dialog-form >>> .el-form-item { margin-bottom: 16px; }
.query-dialog-form >>> .el-form-item:last-child { margin-bottom: 0; }
.code-link { cursor: pointer; color: #348adb; }
.hidden-order-page { display: none; }
</style>
